import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
 apiKey: "AIzaSyBH-fL--MEiGp1XJsOc7M2e6SiG8kdKdlI",
 authDomain: "flyshitnyc.firebaseapp.com",
 projectId: "flyshitnyc",
 storageBucket: "flyshitnyc.firebasestorage.app",
 messagingSenderId: "746770984137",
 appId: "1:746770984137:web:ced5dd9b0c870d30db7118",
 measurementId: "G-0CC5DE8RBX",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
